import {Component, OnInit, OnDestroy, inject, Input} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Subject, Subscription} from "rxjs";
import {HeaderService} from "../../services/header.service";
import {OrganizationsService} from "../../services/organizations.service";
import {Organization} from "../../interfaces/organization";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  @Input() dataRouteSubject: Subscription;

  private isDestroyed: Subject<boolean> = new Subject();
  activatedRoute = inject(ActivatedRoute);
  headerService = inject(HeaderService);
  private organizationsService = inject(OrganizationsService);

  pageType: number = 0;
  userInfo;
  mobileMenuShow = false;
  isDarkBackground = false;
  public activeOrganization: Organization;

  ngOnInit(): void {
    this.dataRouteSubject = this.activatedRoute.data.subscribe(data => {
      this.pageType = data['type'];
    });

    this.headerService.userData
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(data => {
        this.userInfo = data;
      })

    this.organizationsService.organizations$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((organizations: Organization[]) => {
        if (!organizations || !organizations.length) {
          return;
        }

        this.activeOrganization = organizations.find((org) => org.is_active === '1' || org.is_active === true);
      });
  }

  userMobileMenuShow() {
    this.mobileMenuShow = true;
    this.isDarkBackground = true;
  }

  closeMobileMenu() {
    this.mobileMenuShow = false;
    this.isDarkBackground = false;
  }

  // userData и organizations$ - root-сабжекты: без отписки каждый заход на страницу
  // с меню оставлял живую подписку, держащую уничтоженный компонент
  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }

}
